module.exports = __webpack_public_path__ + "static/media/male2.721510f0.png";